module.exports = __webpack_public_path__ + "img/9b5dfc7.png";